import { nextTick } from 'vue';

/** 폰트 크기 조정 시 감소할 단위 (px) */
const FONT_SIZE_DECREMENT = 0.1;

function downFontSize(element: HTMLElement, minFontSize: number) {
    const isVerticalScroll = element.scrollHeight > element.clientHeight;
    const isHorizontalScroll = element.scrollWidth > element.clientWidth;

    if (!isVerticalScroll && !isHorizontalScroll) {
        return;
    }

    const fontSize = getComputedStyle(element).fontSize.replace('px', '');
    element.style.fontSize = `${Number(fontSize) - FONT_SIZE_DECREMENT}px`;

    // 자식 요소 fontSize도 줄임
    Array.from(element.children).forEach((child) => {
        if (child instanceof HTMLElement) {
            const childFontSize = getComputedStyle(child).fontSize.replace('px', '');
            child.style.fontSize = `${Number(childFontSize) - FONT_SIZE_DECREMENT}px`;
        }
    });
    if (Number(fontSize) - FONT_SIZE_DECREMENT <= minFontSize) {
        return;
    }

    nextTick(() => {
        downFontSize(element, minFontSize);
    });
}

export const textFit = (el: HTMLElement, minFontSize = 12) => {
    downFontSize(el, minFontSize);
};

type TextFitElement = HTMLElement & {
    __textFitObserver__?: IntersectionObserver;
};

export const textFitDirective = {
    mounted(el: HTMLElement) {
        const element = el as TextFitElement;

        // IntersectionObserver를 지원하지 않는 환경에서는 한 번만 실행
        if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
            textFit(element);

            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    textFit(element);
                }
            });
        });

        observer.observe(element);
        element.__textFitObserver__ = observer;

        // 초기 렌더 시 바로 한 번 실행
        textFit(element);
    },
    unmounted(el: HTMLElement) {
        const element = el as TextFitElement;

        if (element.__textFitObserver__) {
            element.__textFitObserver__.disconnect();
            delete element.__textFitObserver__;
        }
    },
};
